import script from "./SubscriptionExpiredModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionExpiredModal.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionExpiredModal.vue?vue&type=style&index=0&id=cfd6c1c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfd6c1c0"]])

export default __exports__